import { render, staticRenderFns } from "./desuLimitGoodClassify.vue?vue&type=template&id=9c5d8698&scoped=true"
import script from "./desuLimitGoodClassify.vue?vue&type=script&lang=js"
export * from "./desuLimitGoodClassify.vue?vue&type=script&lang=js"
import style0 from "./desuLimitGoodClassify.vue?vue&type=style&index=0&id=9c5d8698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5d8698",
  null
  
)

export default component.exports